/* =========================================================================== *\
 __      __.__     ___________           .__    ____ ________  ________.________
/  \    /  \__| ___\__    ___/___   ____ |  |__/_   /   __   \/   __   \   ____/
\   \/\/   /  |/    \|    |_/ __ \_/ ___\|  |  \|   \____    /\____    /____  \ 
 \        /|  |   |  \    |\  ___/\  \___|   Y  \   |  /    /    /    //       \
  \__/\  / |__|___|  /____| \___  >\___  >___|  /___| /____/    /____//______  /
       \/          \/           \/     \/     \/                             \/ 
\* =========================================================================== */

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import Iframe from 'react-iframe';

// @mui material components
import Icon from '@mui/material/Icon';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import MenuItem from '@mui/material/MenuItem';
import Tooltip from '@mui/material/Tooltip';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDButton from 'components/MDButton';
import MDSnackbar from 'components/MDSnackbar';
import MDInput from 'components/MDInput';
import MDSelect from 'components/MDSelect';
import MDTypography from 'components/MDTypography';
import MDCheckbox from 'components/MDCheckbox';

// Material Dashboard 2 PRO React examples
import { useTranslation } from 'react-i18next';
import { APP_STATE } from 'services/Define';
import { FetchData } from 'services/Request';
import { useSelector } from 'react-redux';
import * as Func from 'services/Function';
import ProductPackaging from './ProductPackaging';

const initAttr = {
  id: '',
  product_id: '',
  barcode: '',
  barcode2: '',
  unit_id: '',
  color_id: '',
  size_id: '',
  best_id: '',
  name: '',
  ratio: '1.000000',
  cost: '',
  cost_sell: '',
  cost_markup: '',
  price: '',
  min_stock: '0',
  max_stock: '999999',
  color: '#ffffff',
  color_name: '',
  packaging_id: '',
  unit_name: '',
  size_name: '',
  product_main: 'N',
  check_stock: 'N',
  enable: 'Y',
  sell_online: 'Y',
  change_unit: 'Y',
  price_auto: 'Y',
  created_at: '',
  updated_at: '',
};

const initParent = {
  id: '',
  sku: '',
  cat_id: '',
  subcat_id: '',
  image_id: '',
  unit_id: '',
  unitadd_id: '',
  unitbuy_id: '',
  brand_id: '',
  color_id: '',
  vat_type: 'NO',
  image: '',
  name: '',
  name_en: '',
  detail: '',
  detail_en: '',
  content: '',
  content_en: '',
  drug_type_9: 'N',
  drug_type_10: 'N',
  drug_type_11: 'N',
  autoid: 'Y',
  autoprefix: 'RT',
  cost: '',
  price: '',
  youtube: '',
  min_stock: '',
  max_stock: '',
  active_buy: 'Y',
  enable: 'Y',
  created_at: '',
  updated_at: '',
};

const initFind = {
  search: '',
  page: 1,
};

function ProductBarcode() {
  const mod = 'product_barcode';
  const app = useSelector((state) => state[APP_STATE]);
  const { t, i18n } = useTranslation();
  const { id } = useParams();
  const [record, setRecord] = useState([]);
  const [parent, setParent] = useState(initParent);
  const [attr, setAttr] = useState(initAttr);
  const [find, setFind] = useState(initFind);
  const [notify, setNotify] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modalAdd, setModalAdd] = useState(false);
  const [modalEdit, setModalEdit] = useState(false);
  const [modalColor, setModalColor] = useState(false);
  const [modalSize, setModalSize] = useState(false);
  const [modalUnit, setModalUnit] = useState(false);
  const [modalPrint, setModalPrint] = useState(false);
  const [cboUnit, setCboUnit] = useState([]);
  const [cboColor, setCboColor] = useState([]);
  const [cboSize, setCboSize] = useState([]);
  const [abc, setAbc] = useState({ id: '', value: null });
  const [qrcode, setQrCode] = useState('');
  const [printUrl, setPrintUrl] = useState('');

  const showNotify = (msg, color) => {
    setNotify(
      <MDSnackbar
        color={color}
        icon='notifications'
        title={t(`app.name`)}
        content={msg}
        dateTime={Func.dateTimeDisplay()}
        open={Boolean(true)}
        close={() => setNotify(!notify)}
      />
    );

    setTimeout(function () {
      setNotify(null);
    }, 3000);
  };

  const view = (data) => {
    setFind(data);
    setLoading(true);

    FetchData('POST', `/${mod}`, app.token, {
      lang: app.lang,
      search: data.search,
      ref_id: id,
    }).then((result) => {
      if (result.status === 'ok') {
        const ids = result.data.map((r) => r.id);
        setRecord(result.data.map((r) => ({ ...r, best_name: 'กำลังคำนวณ...' })));
        setParent(result.parent);

        FetchData('OPTIONS', `/${mod}/abc`, app.token, { ids }).then((res) => {
          setRecord((prev) =>
            prev.map((r) =>
              ids.includes(r.id)
                ? { ...r, best_name: (res.status === 'ok' && res.data[r.id]) || '-' }
                : r
            )
          );
        });
      }
      setLoading(false);
    });
  };

  const reload = () => {
    view(find);
  };

  const initAdd = () => {
    setAttr({ ...initAttr, price: parent.price, unit_id: parent.unit_id });
    setConfirm(false);
    setModalAdd(true);
  };

  const open = (item) => {
    setLoading(true);
    setConfirm(false);
    setAttr(initAttr);

    FetchData('GET', `/${mod}/${item.id}`, app.token, {
      lang: app.lang,
    }).then((result) => {
      if (result.status === 'ok') {
        setAttr(result.data);
        setModalEdit(true);

        setLoading(false);
      }
    });

    setAbc({ id: item.id, value: null });
    FetchData('OPTIONS', `/${mod}/abc`, app.token, { ids: [item.id] }).then((result) => {
      const value = (result.status === 'ok' && result.data[item.id]) || '-';
      setAbc((prev) => (prev.id === item.id ? { ...prev, value } : prev));
    });
  };

  const pin = (item) => {
    setLoading(true);

    FetchData('OPTIONS', `/${mod}/pin`, app.token, {
      id: item.id,
      image_id: item.image_id,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view(find);
        showNotify(t(`alert.editcomplete`), 'success');
      } else {
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const addConfirm = () => {
    if (!Func.verifyLength(attr.barcode, 1)) return;
    if (!Func.verifyLength(attr.unit_id, 1)) return;

    setConfirm(true);
  };

  const add = () => {
    setLoading(true);
    setModalAdd(false);

    FetchData('PUT', `/${mod}`, app.token, {
      product_id: id,
      barcode: attr.barcode,
      barcode2: attr.barcode2,
      unit_id: attr.unit_id,
      color_id: attr.color_id,
      size_id: attr.size_id,
      name: attr.name,
      min_stock: attr.min_stock,
      max_stock: attr.max_stock,
      check_stock: attr.check_stock,
      cost: attr.cost,
      price: attr.price,
      affiliate: attr.affiliate,
      enable: attr.enable,
      sell_online: attr.sell_online,
      price_auto: attr.price_auto,
      packaging_id: attr.packaging_id,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view(find);
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        setModalAdd(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const pack = (item) => {
    setAttr({
      ...item,
      packaging_id: item.id,
      product_main: 'N',
      barcode: '',
      barcode2: '',
      unit_id: '',
    });
    setConfirm(false);
    setModalAdd(true);
  };

  const addUnitConfirm = () => {
    if (!Func.verifyLength(attr.unit_name, 1)) return;

    setConfirm(true);
  };

  const addUnit = () => {
    setLoading(true);
    setModalUnit(false);

    FetchData('PUT', `/unit`, app.token, {
      name: attr.unit_name,
      ratio: attr.ratio,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        setCboUnit(result.unit);
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        setModalUnit(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const addColorConfirm = () => {
    if (!Func.verifyLength(attr.color_name, 1)) return;

    setConfirm(true);
  };

  const addColor = () => {
    setLoading(true);
    setModalColor(false);

    FetchData('PUT', `/color`, app.token, {
      name: attr.color_name,
      color: attr.color,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        setCboColor(result.color);
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        setModalColor(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const addSizeConfirm = () => {
    if (!Func.verifyLength(attr.size_name, 1)) return;

    setConfirm(true);
  };

  const addSize = () => {
    setLoading(true);
    setModalSize(false);

    FetchData('PUT', `/size`, app.token, {
      name: attr.size_name,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        setCboSize(result.size);
        showNotify(t(`alert.addcomplete`), 'success');
      } else {
        setModalSize(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const editConfirm = () => {
    if (!Func.verifyLength(attr.barcode, 1)) return;

    setConfirm(true);
  };

  const edit = () => {
    setLoading(true);
    setModalEdit(false);

    FetchData('PATCH', `/${mod}/${attr.id}`, app.token, {
      barcode: attr.barcode,
      barcode2: attr.barcode2,
      unit_id: attr.unit_id,
      color_id: attr.color_id,
      size_id: attr.size_id,
      name: attr.name,
      min_stock: attr.min_stock,
      max_stock: attr.max_stock,
      check_stock: attr.check_stock,
      cost: attr.cost,
      price: attr.price,
      affiliate: attr.affiliate,
      enable: attr.enable,
      sell_online: attr.sell_online,
      price_auto: attr.price_auto,
      packaging_id: attr.packaging_id,
      best_id: attr.best_id,
    }).then((result) => {
      setLoading(false);

      if (result.status === 'ok') {
        view(find);
        showNotify(t(`alert.editcomplete`), 'success');
      } else {
        setModalEdit(true);
        showNotify(t(`alert.saveerror`), 'error');
      }
    });
  };

  const del = (item) => {
    Swal.fire({
      title: t(`alert.confirm_delete_title`),
      icon: 'warning',
      showDenyButton: true,
      confirmButtonColor: '#3085d6',
      confirmButtonText: t(`element.deleteconfirm`),
      denyButtonText: t(`element.cancel`),
      denyButtonColor: '#dc3545',
      reverseButtons: true,
    }).then((swal) => {
      if (swal.isConfirmed) {
        setLoading(true);

        FetchData('DELETE', `/${mod}/${item.id}`, app.token, {}).then((result) => {
          setLoading(false);

          if (result.status === 'ok') {
            view(find);
            showNotify(t(`alert.deletecomplete`), 'success');
          } else {
            showNotify(t(`alert.deleteerror`), 'error');
          }
        });
      }
    });
  };

  const print = (barcode) => {
    setLoading(true);

    FetchData('OPTIONS', `/product/print`, app.token, {
      lang: app.lang,
      barcode: barcode,
    }).then((result) => {
      setLoading(false);
      if (result.status === 'ok') {
        setPrintUrl(result.print);
        setQrCode(barcode);
        setModalPrint(true);
      }
    });
  };

  const renderLoading = () => {
    return (
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color='inherit' />
      </Backdrop>
    );
  };

  const init = () => {
    FetchData('GET', `/${mod}`, app.token, {
      ref_id: id,
    }).then((result) => {
      if (result.status === 'ok') {
        setAttr(initAttr);
        setCboColor(result.color);
        setCboSize(result.size);
        setCboUnit(result.unit);
        view(find);
      } else {
        Func.exitApp();
      }
    });
  };

  const renderButton = () => {
    return (
      <MDBox>
        <MDButton
          variant='text'
          color='primary'
          onClick={() => {
            setAttr(initAttr);
            setConfirm(false);
            setModalUnit(true);
          }}
          sx={{ mr: 1 }}
        >
          <Icon>add_circle_outline</Icon>&nbsp; หน่วย
        </MDButton>
        <MDButton
          variant='text'
          color='error'
          onClick={() => {
            setAttr(initAttr);
            setConfirm(false);
            setModalSize(true);
          }}
          sx={{ mr: 1 }}
        >
          <Icon>add_circle_outline</Icon>&nbsp; ขนาด
        </MDButton>
        <MDButton
          variant='text'
          color='warning'
          onClick={() => {
            setAttr(initAttr);
            setConfirm(false);
            setModalColor(true);
          }}
          sx={{ mr: 1 }}
        >
          <Icon>add_circle_outline</Icon>&nbsp; สี
        </MDButton>
        <MDButton color='info' onClick={initAdd}>
          <Icon>add_circle_outline</Icon>&nbsp; SKU
        </MDButton>
      </MDBox>
    );
  };

  const renderSearch = () => {
    return (
      <MDBox
        noValidate
        component='form'
        role='form'
        onSubmit={(e) => {
          e.preventDefault();
          view({ ...find, page: 1 });
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDInput
              name='searchform'
              fullWidth
              value={find.search}
              onChange={(e) => setFind({ ...find, search: e.target.value, page: 1 })}
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>{t('element.search')} :</InputAdornment>
                ),
                autoComplete: 'off',
              }}
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const btnOpen = (item) => {
    return (
      <Tooltip title='แก้ไข'>
        <MDButton
          variant='text'
          color='info'
          sx={{
            p: 0,
            m: 0,
            fontSize: '1rem',
            display: 'block',
            textAlign: 'left',
            minHeight: 'unset',
          }}
        >
          {item.code}
        </MDButton>
      </Tooltip>
    );
  };

  const btnRefresh = () => {
    return (
      <MDButton
        variant='outlined'
        color='dark'
        onClick={() => {
          view(find);
        }}
        sx={{ mr: 1 }}
      >
        <Icon>refresh</Icon>&nbsp; Refresh
      </MDButton>
    );
  };

  const renderList = () => {
    return (
      <MDBox>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={4} lg={6}>
            {renderSearch()}
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={6} sx={{ textAlign: 'right' }}>
            {renderButton()}
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              {record.map((row) => (
                <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={row.id}>
                  <ProductPackaging
                    row={row}
                    open={open}
                    pin={pin}
                    pack={pack}
                    del={del}
                    print={print}
                    reload={reload}
                    key={row.id}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderProductInfo = () => {
    return (
      <MDBox className='card' p={2}>
        <MDTypography variant='h6' mb={3}>
          ข้อมูลสินค้า
        </MDTypography>
        <Grid container spacing={2}>
          {attr.product_main === 'Y' ? null : (
            <Grid item xs={12}>
              <MDInput
                label='กลุ่ม'
                variant='standard'
                fullWidth
                value={attr.packaging_id}
                defaultValue=''
                select
                onChange={(e) => setAttr({ ...attr, packaging_id: e.target.value })}
              >
                <MenuItem value='0'>กลุ่มหลัก</MenuItem>
                {record.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.barcode} : {item.unit_name}
                  </MenuItem>
                ))}
              </MDInput>
            </Grid>
          )}
          <Grid item xs={12}>
            <MDInput
              label='Barcode *'
              onChange={(e) => setAttr({ ...attr, barcode: e.target.value })}
              value={attr.barcode}
              variant='standard'
              fullWidth
              InputProps={{
                autoComplete: 'off',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label='Barcode 2'
              onChange={(e) => setAttr({ ...attr, barcode2: e.target.value })}
              value={attr.barcode2}
              variant='standard'
              fullWidth
              InputProps={{
                autoComplete: 'off',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label='ชื่อ'
              onChange={(e) => setAttr({ ...attr, name: e.target.value })}
              value={attr.name}
              variant='standard'
              fullWidth
              multiline
              InputProps={{
                autoComplete: 'off',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDSelect
              label='สี'
              labelDefault={t(`element.please_select`)}
              data={cboColor}
              value={attr.color_id}
              onChange={(e) => setAttr({ ...attr, color_id: e.target.value })}
              inputProps={{
                autoComplete: 'off',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDSelect
              label='ขนาด'
              labelDefault={t(`element.please_select`)}
              data={cboSize}
              value={attr.size_id}
              onChange={(e) => setAttr({ ...attr, size_id: e.target.value })}
              inputProps={{
                autoComplete: 'off',
              }}
            />
          </Grid>
          {/* {attr.product_main === "Y" ? null : (
            <Grid item xs={12}>
              <MDSelect
                label="หน่วยนับ"
                labelDefault={t(`element.please_select`)}
                data={cboUnit}
                value={attr.unit_id}
                onChange={(e) => setAttr({ ...attr, unit_id: e.target.value })}
                inputProps={{
                  autoComplete: "off",
                  readOnly: attr.change_unit === "N",
                }}
              />
            </Grid>
          )} */}
          <Grid item xs={12}>
            <MDSelect
              label='หน่วยนับ'
              labelDefault={t(`element.please_select`)}
              data={cboUnit}
              value={attr.unit_id}
              onChange={(e) => setAttr({ ...attr, unit_id: e.target.value })}
              inputProps={{
                autoComplete: 'off',
                readOnly: attr.change_unit === 'N',
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDCheckbox
              label='เปิดขายหน้าร้าน'
              checked={attr.enable === 'Y'}
              onChange={(e) => setAttr({ ...attr, enable: e.target.checked ? 'Y' : 'N' })}
            />
          </Grid>
          <Grid item xs={12}>
            <MDCheckbox
              label='เปิดขาย ONLINE'
              checked={attr.sell_online === 'Y'}
              onChange={(e) => setAttr({ ...attr, sell_online: e.target.checked ? 'Y' : 'N' })}
            />
          </Grid>
        </Grid>
      </MDBox>
    );
  };

  const renderAbc = () => {
    if (!modalEdit || !attr.id) return null;

    return (
      <Grid item xs={12}>
        <MDInput
          label='ABC (คำนวณจากยอดขาย 3 เดือน)'
          value={abc.id === attr.id && abc.value !== null ? abc.value : 'กำลังคำนวณ...'}
          variant='standard'
          fullWidth
          InputProps={{ readOnly: true }}
        />
      </Grid>
    );
  };

  const renderPriceMainInfo = () => {
    return (
      <MDBox className='card' p={2}>
        <MDTypography variant='h6' mb={3}>
          ข้อมูลการขาย
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDInput
              label='ราคาซื้อ'
              onFocus={(e) => e.target.select()}
              onChange={(e) => setAttr({ ...attr, cost: e.target.value })}
              value={attr.cost}
              variant='standard'
              type='number'
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <MDTypography variant='body'>บาท</MDTypography>
                  </InputAdornment>
                ),
                inputProps: {
                  className: 'text-right',
                  autoComplete: 'off',
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label='ราคาขาย'
              onFocus={(e) => e.target.select()}
              onChange={(e) => setAttr({ ...attr, price: e.target.value })}
              value={attr.price}
              variant='standard'
              type='number'
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <MDTypography variant='body'>บาท</MDTypography>
                  </InputAdornment>
                ),
                inputProps: {
                  className: 'text-right',
                  autoComplete: 'off',
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <MDInput
              label='ค่าหยิบสินค้า'
              onFocus={(e) => e.target.select()}
              onChange={(e) => setAttr({ ...attr, affiliate: e.target.value })}
              value={attr.affiliate}
              variant='standard'
              type='number'
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <MDTypography variant='body'>บาท</MDTypography>
                  </InputAdornment>
                ),
                inputProps: {
                  className: 'text-right',
                  autoComplete: 'off',
                },
              }}
            />
          </Grid>
          {renderAbc()}
        </Grid>
      </MDBox>
    );
  };

  const renderPriceInfo = () => {
    return (
      <MDBox className='card' p={2}>
        <MDTypography variant='h6' mb={3}>
          ข้อมูลราคา
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDCheckbox
              label='เพิ่มราคาอัตโนมัติ'
              checked={attr.price_auto === 'Y'}
              onChange={(e) => setAttr({ ...attr, price_auto: e.target.checked ? 'Y' : 'N' })}
            />
          </Grid>
          {attr.price_auto === 'Y' ? null : (
            <Grid item xs={12}>
              <MDInput
                label='ราคาซื้อ'
                onFocus={(e) => e.target.select()}
                onChange={(e) => setAttr({ ...attr, cost: e.target.value })}
                value={attr.cost}
                variant='standard'
                type='number'
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <MDTypography variant='body'>บาท</MDTypography>
                    </InputAdornment>
                  ),
                  inputProps: {
                    className: 'text-right',
                    autoComplete: 'off',
                  },
                }}
              />
            </Grid>
          )}
          {attr.price_auto === 'Y' ? null : (
            <Grid item xs={12}>
              <MDInput
                label='ราคาขาย'
                onFocus={(e) => e.target.select()}
                onChange={(e) => setAttr({ ...attr, price: e.target.value })}
                value={attr.price}
                variant='standard'
                type='number'
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <MDTypography variant='body'>บาท</MDTypography>
                    </InputAdornment>
                  ),
                  inputProps: {
                    className: 'text-right',
                    autoComplete: 'off',
                  },
                }}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <MDInput
              label='ค่าหยิบสินค้า'
              onFocus={(e) => e.target.select()}
              onChange={(e) => setAttr({ ...attr, affiliate: e.target.value })}
              value={attr.affiliate}
              variant='standard'
              type='number'
              fullWidth
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <MDTypography variant='body'>บาท</MDTypography>
                  </InputAdornment>
                ),
                inputProps: {
                  className: 'text-right',
                  autoComplete: 'off',
                },
              }}
            />
          </Grid>
          {renderAbc()}
        </Grid>
      </MDBox>
    );
  };

  const renderStockInfo = () => {
    return (
      <MDBox className='card' p={2}>
        <MDTypography variant='h6' mb={3}>
          ข้อมูลคลังสินค้า
        </MDTypography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <MDCheckbox
              label='ตรวจสอบปริมาณ'
              checked={attr.check_stock === 'Y'}
              onChange={(e) => setAttr({ ...attr, check_stock: e.target.checked ? 'Y' : 'N' })}
            />
          </Grid>
          {attr.check_stock === 'N' ? null : (
            <Grid item xs={12}>
              <MDInput
                label='ปริมาณขั้นต่ำ'
                onFocus={(e) => e.target.select()}
                onChange={(e) => setAttr({ ...attr, min_stock: e.target.value })}
                value={attr.min_stock}
                variant='standard'
                type='number'
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <MDTypography variant='body'>{attr.unit_name}</MDTypography>
                    </InputAdornment>
                  ),
                  inputProps: {
                    className: 'text-right',
                    autoComplete: 'off',
                  },
                }}
              />
            </Grid>
          )}
          {attr.check_stock === 'N' ? null : (
            <Grid item xs={12}>
              <MDInput
                label='ปริมาณสูงสุด'
                onFocus={(e) => e.target.select()}
                onChange={(e) => setAttr({ ...attr, max_stock: e.target.value })}
                value={attr.max_stock}
                variant='standard'
                type='number'
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <MDTypography variant='body'>{attr.unit_name}</MDTypography>
                    </InputAdornment>
                  ),
                  inputProps: {
                    className: 'text-right',
                    autoComplete: 'off',
                  },
                }}
              />
            </Grid>
          )}
        </Grid>
      </MDBox>
    );
  };

  const renderAdd = () => {
    return (
      <Dialog open={modalAdd} maxWidth='lg' keepMounted aria-describedby='dialog-add' fullWidth>
        <DialogTitle>
          {t(`element.add`)}
          <IconButton
            aria-label='close'
            onClick={() => setModalAdd(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ minHeight: 500 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} xl={4}>
              {renderProductInfo()}
            </Grid>
            <Grid item xs={12} sm={6} xl={4}>
              {renderPriceInfo()}
            </Grid>
            <Grid item xs={12} sm={6} xl={4}>
              {renderStockInfo()}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={add}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='info' onClick={addConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderColor = () => {
    return (
      <Dialog open={modalColor} maxWidth='xs' keepMounted aria-describedby='dialog-add' fullWidth>
        <DialogTitle>
          {t(`element.add`)} สี
          <IconButton
            aria-label='close'
            onClick={() => setModalColor(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDInput
                  label='ชื่อสี'
                  onChange={(e) => setAttr({ ...attr, color_name: e.target.value })}
                  value={attr.color_name}
                  variant='standard'
                  fullWidth
                  InputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label='เลือกสี'
                  onChange={(e) => setAttr({ ...attr, color: e.target.value })}
                  value={attr.color}
                  variant='standard'
                  type='color'
                  fullWidth
                  InputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={addColor}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='info' onClick={addColorConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderUnit = () => {
    return (
      <Dialog open={modalUnit} maxWidth='xs' keepMounted aria-describedby='dialog-add' fullWidth>
        <DialogTitle>
          {t(`element.add`)} หน่วย
          <IconButton
            aria-label='close'
            onClick={() => setModalUnit(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDInput
                  label='ชื่อหน่วย'
                  onChange={(e) => setAttr({ ...attr, unit_name: e.target.value })}
                  value={attr.unit_name}
                  variant='standard'
                  fullWidth
                  InputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <MDInput
                  label='อัตราแปลงหน่วย'
                  onChange={(e) => setAttr({ ...attr, ratio: e.target.value })}
                  onFocus={(e) => e.target.select()}
                  value={attr.ratio}
                  variant='standard'
                  type='number'
                  fullWidth
                  InputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={addUnit}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='info' onClick={addUnitConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderSize = () => {
    return (
      <Dialog open={modalSize} maxWidth='xs' keepMounted aria-describedby='dialog-add' fullWidth>
        <DialogTitle>
          {t(`element.add`)} ขนาด
          <IconButton
            aria-label='close'
            onClick={() => setModalSize(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox p={3}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MDInput
                  label='ชื่อขนาด'
                  onChange={(e) => setAttr({ ...attr, size_name: e.target.value })}
                  value={attr.size_name}
                  variant='standard'
                  fullWidth
                  InputProps={{
                    autoComplete: 'off',
                  }}
                />
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={addSize}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='info' onClick={addSizeConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderEdit = () => {
    return (
      <Dialog
        open={modalEdit}
        maxWidth='lg'
        keepMounted
        aria-describedby='dialog-edit'
        fullWidth
        sx={{ minHeight: 500 }}
      >
        <DialogTitle>
          {t(`element.edit`)} : {attr.barcode}
          <IconButton
            aria-label='close'
            onClick={() => setModalEdit(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} xl={4}>
              {renderProductInfo()}
            </Grid>
            <Grid item xs={12} sm={6} xl={4}>
              {attr.product_main === 'Y' ? renderPriceMainInfo() : renderPriceInfo()}
            </Grid>
            <Grid item xs={12} sm={6} xl={4}>
              {renderStockInfo()}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {confirm ? (
            <Grid container>
              <Grid item xs={6}>
                <MDButton variant='text' color='error' onClick={() => setConfirm(false)}>
                  <Icon>cancel</Icon>&nbsp;{t(`element.cancel`)}
                </MDButton>
              </Grid>
              <Grid item xs={6} display='flex' justifyContent='flex-end'>
                <MDButton variant='outlined' color='success' onClick={edit}>
                  <Icon>save</Icon>&nbsp;{t(`element.saveconfirm`)}
                </MDButton>
              </Grid>
            </Grid>
          ) : (
            <MDButton variant='text' color='success' onClick={editConfirm}>
              <Icon>save</Icon>&nbsp;{t(`element.save`)}
            </MDButton>
          )}
        </DialogActions>
      </Dialog>
    );
  };

  const renderPrint = () => {
    return (
      <Dialog
        open={modalPrint}
        maxWidth='xs'
        keepMounted
        aria-describedby='dialog-print'
        fullWidth
        onClose={() => setModalPrint(false)}
      >
        <DialogTitle>
          {qrcode}
          <IconButton
            aria-label='close'
            onClick={() => setModalPrint(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <Icon>close</Icon>
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0 }}>
          {printUrl === '' ? null : (
            <Iframe
              url={printUrl}
              width='100%'
              height='300'
              id='print'
              className=''
              display='initial'
              position='relative'
              frameBorder='0'
            />
          )}
        </DialogContent>
      </Dialog>
    );
  };

  useEffect(() => {
    i18n.changeLanguage(app.lang);

    init();
  }, [id]);

  return (
    <div>
      {renderList()}
      {renderAdd()}
      {renderUnit()}
      {renderColor()}
      {renderSize()}
      {renderEdit()}
      {renderPrint()}
      {renderLoading()}
      {notify}
    </div>
  );
}

export default ProductBarcode;
